<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
    <vue-scroll class="pb-20">
        <div class="page-header">
            <h1 v-if="community">Edit Community: {{ community.name }}</h1>
            <h1 v-else>Create Community</h1>
        </div>
        <div style="padding-bottom: 10px">
            <invoice-payment-link
                :community-id="community.id"
                v-if="community && !community.is_bill_to_account_only"
            ></invoice-payment-link>
        </div>
        <el-form @submit.prevent="submit()" style="max-width: 700px">
            <el-form-item label="Name" required :class="form.state('name')">
                <el-input
                    class="el-input--uppercase"
                    name="name"
                    v-model="form.name"
                    v-validate="'required'"
                />
                <form-feedback :form="form" field="name" />
            </el-form-item>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="Subdomain" :class="form.state('slug')">
                        <el-input v-model="form.slug" />
                        <form-feedback :form="form" field="slug" />
                        <div
                            v-if="community && community.slug"
                            class="login-url-container"
                        >
                            <el-link
                                :href="loginUrl"
                                target="_blank"
                                type="primary"
                            >
                                {{ loginUrl }}
                                <i class="mdi mdi-open-in-new ml-1"></i>
                            </el-link>
                            <el-button
                                type="text"
                                size="small"
                                @click="copyLoginUrl"
                                class="ml-2"
                                title="Copy URL"
                            >
                                <i class="mdi mdi-content-copy"></i>
                            </el-button>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        :class="form.state('code')"
                        label="Community Code"
                        required
                    >
                        <el-input
                            class="el-input--uppercase"
                            name="code"
                            v-model="form.code"
                            v-validate="'required'"
                        />
                        <form-feedback :form="form" field="code" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item
                :class="form.state('phone_number')"
                label="Phone Number"
                required
            >
                <el-input
                    data-vv-as="phone number"
                    name="phone_number"
                    v-model="form.phone_number"
                    v-validate="'required'"
                />
                <form-feedback :form="form" field="phone_number" />
            </el-form-item>
            <el-form-item :class="form.state('notes')" label="Notes">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    v-model="form.notes"
                    name="notes"
                />
                <form-feedback :form="form" field="notes" />
            </el-form-item>
            <el-form-item
                :class="form.state('popup_message')"
                label="Popup Message to Client at Login"
            >
                <el-input
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    name="popup_message"
                    type="textarea"
                    v-model="form.popup_message"
                />
                <form-feedback :form="form" field="popup_message" />
            </el-form-item>
            <el-form-item
                :class="form.state('announcement')"
                label="Announcement"
            >
                <el-input
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    name="announcement"
                    type="textarea"
                    v-model="form.announcement"
                />
                <form-feedback :form="form" field="announcement" />
            </el-form-item>
            <h4>Address</h4>
            <el-row :gutter="20">
                <el-col :md="12">
                    <el-form-item
                        required
                        label="Street"
                        :class="form.state(`address.street`)"
                    >
                        <el-input
                            class="el-input--uppercase"
                            name="address_line1"
                            v-model="form.address.street"
                        />
                        <form-feedback :form="form" :field="`address.street`" />
                    </el-form-item>
                </el-col>
                <el-col :md="12">
                    <el-form-item
                        required
                        label="City"
                        :class="form.state(`address.city`)"
                    >
                        <el-input
                            class="el-input--uppercase"
                            name="city"
                            v-model="form.address.city"
                        />
                        <form-feedback :form="form" :field="`address.city`" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :md="12">
                    <el-form-item
                        required
                        label="State"
                        :class="form.state(`address.state`)"
                    >
                        <state-select
                            name="state"
                            v-model="form.address.state"
                        />
                        <form-feedback :form="form" :field="`address.state`" />
                    </el-form-item>
                </el-col>
                <el-col :md="12">
                    <el-form-item
                        required
                        label="Zip"
                        :class="form.state(`address.zip`)"
                    >
                        <el-input
                            class="el-input--uppercase"
                            name="zip"
                            v-model="form.address.zip"
                        />
                        <form-feedback :form="form" :field="`address.zip`" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <edit-logo :community="community" :form="form" />
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        :class="form.state('disable_custom_shipping')"
                        label="Disable Expedited Shipping Options"
                    >
                        <br />
                        <el-switch v-model="form.disable_custom_shipping" />
                        <form-feedback
                            :form="form"
                            field="disable_custom_shipping"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                        :class="form.state('corporation_id')"
                        label="Corporation"
                    >
                        <el-select
                            @change="onChangeCorporation"
                            clearable
                            filterable
                            placeholder="Select"
                            v-model="form.corporation_id"
                        >
                            <el-option :value="null" label="INDEPENDENT">
                            </el-option>
                            <el-option
                                :key="data_index"
                                :label="$options.filters.uppercase(item.name)"
                                :value="item.id"
                                v-for="(item, data_index) in corporations.data"
                            >
                            </el-option>
                        </el-select>
                        <form-feedback :form="form" field="corporation_id" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        :class="form.state('tax_exempt')"
                        label="Tax Exempt"
                    >
                        <br />
                        <el-switch v-model="form.tax_exempt" />
                        <form-feedback :form="form" field="tax_exempt" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item
                :class="form.state('has_ups_account')"
                v-if="!form.corporation_id"
            >
                <el-checkbox v-model="form.has_ups_account">
                    Has Own UPS Account
                </el-checkbox>
                <form-feedback :form="form" field="has_ups_account" />
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item
                        required
                        label="Subscription Type"
                        :class="form.state('account_type')"
                    >
                        <br />
                        <el-radio-group
                            name="account_type"
                            v-validate="'required'"
                            data-vv-as="subscription type"
                            @change="onChangeSubscriptionType"
                            v-model="form.account_type"
                            class="el-radio-group--one-item-per-line"
                        >
                            <el-radio :label="AccountTypes.CALENDARS_ONLY"
                                >Calendar(s)</el-radio
                            >
                            <el-radio :label="AccountTypes.NEWSLETTER_ONLY"
                                >Newsletter</el-radio
                            >
                            <el-radio
                                :label="AccountTypes.CALENDARS_AND_NEWSLETTER"
                                >Calendar(s) and Newsletter
                            </el-radio>
                        </el-radio-group>
                        <form-feedback :form="form" field="account_type" />
                    </el-form-item>
                    <el-form-item
                        required
                        v-if="hasNewsletter"
                        label="Newsletter"
                        :class="form.state('newsletter_type_id')"
                    >
                        <br />
                        <div
                            class="el-radio-group--one-item-per-line"
                            v-for="(
                                type, newsletter_type_index
                            ) in newsletterTypes"
                            :key="newsletter_type_index"
                        >
                            <template>
                                <el-radio
                                    v-model="form.newsletter_type_id"
                                    @change="onChangeNewsletterType"
                                    :label="type.id"
                                    name="newsletter_type_id"
                                    >{{ type.name }}
                                </el-radio>
                                <template v-if="hasNewsletter && hasCalendar">
                                    <div
                                        class="ml-20"
                                        v-if="
                                            type.id ===
                                            NewsletterTypes.BASIC_COMBO
                                        "
                                    >
                                        <el-radio-group
                                            name="newsletter_subtype"
                                            v-validate="{
                                                required:
                                                    form.newsletter_type_id ===
                                                    NewsletterTypes.BASIC_COMBO
                                            }"
                                            :disabled="
                                                form.newsletter_type_id !==
                                                NewsletterTypes.BASIC_COMBO
                                            "
                                            data-vv-as="additional option"
                                            v-model="form.newsletter_subtype"
                                            class="el-radio-group--one-item-per-line"
                                        >
                                            <el-radio
                                                :label="
                                                    NewsletterSubtypes.COLOR
                                                "
                                                >Color</el-radio
                                            >
                                            <el-radio
                                                :label="
                                                    NewsletterSubtypes.BLACK
                                                "
                                                >Black Ink</el-radio
                                            >
                                        </el-radio-group>
                                        <form-feedback
                                            v-if="
                                                form.newsletter_type_id ===
                                                NewsletterTypes.BASIC_COMBO
                                            "
                                            :form="form"
                                            field="newsletter_subtype"
                                        />
                                    </div>
                                    <div
                                        class="ml-20"
                                        v-if="
                                            type.id ===
                                            NewsletterTypes.FLEX_FOUR
                                        "
                                    >
                                        <el-radio-group
                                            name="newsletter_subtype"
                                            v-validate="{
                                                required:
                                                    form.newsletter_type_id ===
                                                    NewsletterTypes.FLEX_FOUR
                                            }"
                                            data-vv-as="additional option"
                                            :disabled="
                                                form.newsletter_type_id !==
                                                NewsletterTypes.FLEX_FOUR
                                            "
                                            v-model="form.newsletter_subtype"
                                            class="el-radio-group--one-item-per-line"
                                        >
                                            <el-radio
                                                :label="
                                                    NewsletterSubtypes.COLLATE_WITH_CALENDAR
                                                "
                                                >Collate with Calendar
                                            </el-radio>
                                            <el-radio
                                                :label="
                                                    NewsletterSubtypes.SHIP_FLAT_WITH_CALENDAR
                                                "
                                                >Ship Flat with Calendar
                                            </el-radio>
                                        </el-radio-group>
                                        <form-feedback
                                            v-if="
                                                form.newsletter_type_id ===
                                                NewsletterTypes.FLEX_FOUR
                                            "
                                            :form="form"
                                            field="newsletter_subtype"
                                        />
                                    </div>
                                </template>
                            </template>
                        </div>
                        <form-feedback
                            :form="form"
                            field="newsletter_type_id"
                        />
                    </el-form-item>
                    <el-form-item
                        required
                        label="Payment Type"
                        :class="form.state('payment_type')"
                    >
                        <br />
                        <el-radio-group
                            name="payment_type"
                            v-validate="'required'"
                            data-vv-as="payment type"
                            @change="onChangeSubscriptionType"
                            v-model="form.payment_type"
                            class="el-radio-group--one-item-per-line"
                        >
                            <el-radio :label="PaymentTypes.BOTH_OPTIONS"
                                >Both options available</el-radio
                            >
                            <el-radio :label="PaymentTypes.BILL_TO_ACCOUNT"
                                >Bill Me only</el-radio
                            >
                            <el-radio :label="PaymentTypes.IMMEDIATE"
                                >Credit Card only</el-radio
                            >
                        </el-radio-group>
                        <form-feedback :form="form" field="account_type" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Start Month">
                        <el-date-picker
                            v-model="form.subscription_start"
                            value-format="yyyy-MM-dd"
                            type="month"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="mb-0">
                        <el-radio
                            v-model="form.subscription_interval"
                            :label="12"
                            name="newsletter_type_id"
                        >
                            Annual Subscription
                        </el-radio>
                    </el-form-item>
                    <el-form-item>
                        <el-input-number
                            :disabled="form.subscription_interval !== 12"
                            v-model.number="form.subscription_yearly_amount"
                            :precision="2"
                            :step="1"
                        />
                    </el-form-item>
                    <el-form-item class="mb-0">
                        <el-radio
                            v-model="form.subscription_interval"
                            :label="1"
                            name="newsletter_type_id"
                        >
                            Monthly Subscription
                        </el-radio>
                    </el-form-item>
                    <el-form-item>
                        <el-input-number
                            :disabled="form.subscription_interval !== 1"
                            v-model.number="form.subscription_monthly_amount"
                            :precision="2"
                            :step="1"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <h3>
            {{ form.users.length }} User<span v-if="form.users.length !== 1"
                >s</span
            >
        </h3>
        <communityUsers
            :form="form"
            :community="community"
            :corporation="selectedCorporation"
        />
        <el-form style="max-width: 700px">
            <div class="community-locations mb-20">
                <h3>
                    {{ form.locations.length }} Calendar<span
                        v-if="form.locations.length !== 1"
                        >s</span
                    >
                </h3>
                <el-form-item
                    label="Current Issue"
                    required
                    :class="form.state('current_issue')"
                >
                    <el-date-picker
                        v-model="form.current_issue"
                        value-format="yyyy-MM-dd"
                        type="month"
                    >
                    </el-date-picker>
                    <form-feedback :form="form" field="current_issue" />
                </el-form-item>
                <div
                    v-for="(location, location_index) in form.locations"
                    :key="location_index"
                    class="community-locations__item"
                >
                    <el-row :gutter="20">
                        <el-col :md="9">
                            <el-form-item
                                required
                                label="Calendar Unit Name"
                                :class="
                                    form.state(
                                        `locations.${location_index}.name`
                                    )
                                "
                            >
                                <el-input
                                    :name="`locations.${location_index}.name`"
                                    v-validate="'required'"
                                    data-vv-as="location name"
                                    v-model="location.name"
                                />
                                <form-feedback
                                    :form="form"
                                    :field="`locations.${location_index}.name`"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :md="7">
                            <el-form-item
                                label="Calendar Unit Code"
                                :class="
                                    form.state(
                                        `locations.${location_index}.code`
                                    )
                                "
                            >
                                <el-input
                                    :name="`locations.${location_index}.code`"
                                    class="el-input--uppercase"
                                    v-model="location.code"
                                />
                                <form-feedback
                                    :form="form"
                                    :field="`locations.${location_index}.code`"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :md="8">
                            <el-form-item
                                label="Format"
                                :class="
                                    form.state(
                                        `locations.${location_index}.calendar_format`
                                    )
                                "
                            >
                                <el-select
                                    v-model="location.calendar_format"
                                    placeholder="Select"
                                >
                                    <el-option
                                        label="Monthly"
                                        :value="CalendarFormats.MONTHLY"
                                    >
                                    </el-option>
                                    <el-option
                                        label="Weekly"
                                        :value="CalendarFormats.WEEKLY"
                                    >
                                    </el-option>
                                </el-select>
                                <form-feedback
                                    :form="form"
                                    :field="`locations.${location_index}.start_date`"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="float-right">
                        <el-form-item
                            :class="
                                form.state(
                                    `locations.${location_index}.dd_admin`
                                )
                            "
                            class="d-inline-block dd_admin"
                            label="Digital Display"
                        >
                            <el-switch v-model="location.dd_admin" />
                            <form-feedback
                                :form="form"
                                :field="`locations.${location_index}.dd_admin`"
                            />
                        </el-form-item>
                        <el-dropdown
                            trigger="click"
                            v-if="location.id"
                            @command="(e) => moveLocation(location, e)"
                        >
                            <el-button
                                type="primary"
                                icon="mdi mdi-folder-move"
                                round
                                size="mini"
                            >
                                Move to...
                                <i class="el-icon-arrow-down el-icon--right" />
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="new community"
                                    >New Community</el-dropdown-item
                                >
                                <el-dropdown-item command="existing community"
                                    >Existing Community</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-dropdown
                            trigger="click"
                            v-if="location.id"
                            @command="(e) => copyLocation(location, e)"
                        >
                            <el-button
                                type="primary"
                                icon="mdi mdi-folder-multiple"
                                round
                                size="mini"
                            >
                                Copy to...
                                <i class="el-icon-arrow-down el-icon--right" />
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="new community"
                                    >New Community</el-dropdown-item
                                >
                                <el-dropdown-item command="existing community"
                                    >Existing Community</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button
                            type="danger"
                            round
                            size="mini"
                            icon="mdi mdi-delete"
                            @click="removeLocation(location)"
                            >Delete
                        </el-button>
                    </div>
                    <div class="clearfix"></div>
                </div>
                <el-button
                    type="primary"
                    size="small"
                    round
                    icon="mdi mdi-plus"
                    @click="newLocation()"
                    >Add Calendar
                </el-button>
            </div>
        </el-form>
        <el-form style="max-width: 700px" v-if="hasNewsletter">
            <div class="community-locations mb-20">
                <h3>Newsletter</h3>
                <el-row :gutter="20">
                    <el-col :md="10">
                        <el-form-item
                            label="Name"
                            :class="form.state(`newsletter_name`)"
                        >
                            <el-input
                                class="el-input--uppercase"
                                name="newsletter_name"
                                v-model="form.newsletter_name"
                            />
                            <form-feedback
                                :form="form"
                                field="newsletter_name"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :md="14">
                        <el-form-item
                            label="Proof Link"
                            :class="form.state(`newsletter_proof_link`)"
                        >
                            <el-input
                                name="newsletter_proof_link"
                                v-model="form.newsletter_proof_link"
                            />
                            <form-feedback
                                :form="form"
                                field="newsletter_proof_link"
                            />
                        </el-form-item>
                        <el-button
                            type="primary"
                            size="small"
                            round
                            icon="mdi mdi-folder-move"
                            @click="goToProofLink()"
                            :disabled="!form.newsletter_proof_link"
                            >Go to link</el-button
                        >
                        <el-button
                            type="primary"
                            size="small"
                            round
                            icon="mdi mdi-folder-multiple"
                            @click="copyProofLink()"
                            :disabled="!form.newsletter_proof_link"
                            >Copy link</el-button
                        >
                        <input
                            type="hidden"
                            id="copy-link"
                            :value="form.newsletter_proof_link"
                        />
                    </el-col>
                </el-row>
            </div>
        </el-form>
        <el-form
            v-for="(type, CustomChargeTypesIndex) in CustomChargeTypes"
            :key="CustomChargeTypesIndex"
        >
            <template>
                <h4 v-if="type === CustomChargeTypes.AMOUNT">
                    Custom Pricing Dollar Amount
                </h4>
                <h4 v-else>Custom Pricing Percentage</h4>
                <table
                    class="w-full table-custom-charges"
                    style="max-width: 600px"
                >
                    <thead>
                        <tr>
                            <td>Description</td>
                            <td>
                                <span v-if="type === CustomChargeTypes.AMOUNT"
                                    >Price Per Issue</span
                                >
                                <span v-else>Discount Percentage</span>
                            </td>
                            <td />
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            class="corporate-discount"
                            v-for="(
                                item, corporateDiscountsIndex
                            ) in corporateDiscounts"
                            :key="corporateDiscountsIndex"
                            v-if="type === CustomChargeTypes.PERCENTAGE"
                        >
                            <td style="vertical-align: top">
                                <el-form-item class="mb-0">
                                    {{ item.name | uppercase }}
                                </el-form-item>
                            </td>
                            <td style="vertical-align: top">
                                <el-form-item class="mb-0">
                                    {{ item.value }}
                                </el-form-item>
                            </td>
                            <td style="vertical-align: top"></td>
                        </tr>
                        <tr
                            v-for="(
                                item, filteredCustomChargesIndex
                            ) in filteredCustomCharges(type)"
                            :key="filteredCustomChargesIndex"
                        >
                            <td style="vertical-align: top">
                                <el-form-item
                                    class="mb-0"
                                    required
                                    :class="form.state(item._name_name)"
                                >
                                    <el-input
                                        :name="item._name_name"
                                        class="el-input--uppercase"
                                        data-vv-as="description"
                                        v-validate="'required'"
                                        v-model="item.name"
                                    />
                                    <form-feedback
                                        :form="form"
                                        :field="item._name_name"
                                    />
                                </el-form-item>
                            </td>
                            <td style="vertical-align: top">
                                <el-form-item
                                    class="mb-0"
                                    required
                                    :class="form.state(item._value_name)"
                                >
                                    <el-input-number
                                        :name="item._value_name"
                                        data-vv-as="value"
                                        v-validate="'required'"
                                        v-if="type === CustomChargeTypes.AMOUNT"
                                        v-model="item.value"
                                        :precision="2"
                                        :step="1"
                                    />
                                    <el-input-number
                                        :name="item._value_name"
                                        data-vv-as="value"
                                        v-validate="'required'"
                                        v-else
                                        v-model="item.value"
                                        :precision="2"
                                        :step="0.1"
                                        :min="0.01"
                                        :max="0.99"
                                    />
                                    <form-feedback
                                        :form="form"
                                        :field="item._value_name"
                                    />
                                </el-form-item>
                            </td>
                            <td style="vertical-align: top">
                                <el-button
                                    class="mt-10"
                                    round
                                    size="mini"
                                    type="danger"
                                    @click="removeCustomCharge(item)"
                                >
                                    Delete
                                </el-button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <el-button
                                    round
                                    size="mini"
                                    type="primary"
                                    @click="addCustomCharge(type)"
                                    >Add</el-button
                                >
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </el-form>
        <div class="community-coupons mb-20">
            <h4>Coupon Code Discount</h4>
            <table
                class="w-full table-custom-charges"
                style="max-width: 600px"
                v-if="this.form.coupon"
            >
                <tbody>
                    <tr class="corporate-discount">
                        <td style="vertical-align: top">
                            <div class="el-form-item mb-0">
                                <div class="el-form-item__content">
                                    {{ this.form.coupon.name }}
                                </div>
                            </div>
                        </td>
                        <td style="vertical-align: top">
                            <div class="el-form-item mb-0">
                                <div
                                    class="el-form-item__content text-uppercase"
                                >
                                    {{ this.form.coupon.code }}
                                </div>
                            </div>
                        </td>
                        <td style="vertical-align: top">
                            <el-button
                                round
                                class="el-button--corwin-green"
                                @click="viewCoupon(form.coupon.id)"
                                >View Details</el-button
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="float-left">
            <el-button
                @click="viewLogs"
                type="primary"
                v-if="community"
                style="min-width: 175px"
                >View Logs
            </el-button>
        </div>
        <div class="float-right">
            <el-button
                @click="deleteCommunity()"
                icon="mdi mdi-delete"
                type="danger"
                v-if="community && can(Permissions.DELETE_COMMUNITY)"
            >
                Delete Community
            </el-button>
            <el-button
                @click="login"
                icon="mdi mdi-login"
                class="el-button--corwin-green"
                v-if="community"
                style="min-width: 175px"
                >Login
            </el-button>
            <el-button @click="back()">Cancel</el-button>
            <el-button
                :loading="form.busy"
                @click="submit"
                icon="mdi mdi-content-save"
                type="primary"
            >
                Save
                <span v-if="community">Changes</span>
            </el-button>
        </div>
        <div class="clearfix"></div>

        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="moveDialogVisible"
            title="Move Calendar to Existing Community"
            width="500px"
        >
            <el-form>
                <el-form-item
                    :class="{
                        'is-error': veeErrors.has('community_id', 'moveForm')
                    }"
                >
                    <el-select
                        data-vv-as="community"
                        data-vv-scope="moveForm"
                        filterable
                        name="community_id"
                        placeholder="Select Community..."
                        v-model="moveForm.community_id"
                        v-validate="'required'"
                    >
                        <el-option
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            v-for="item in availableCommunities"
                        />
                    </el-select>
                    <div
                        class="el-form-item__error"
                        v-if="veeErrors.has('community_id', 'moveForm')"
                    >
                        {{ veeErrors.first("community_id", "moveForm") }}
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="moveDialogVisible = false">Cancel</el-button>
                <el-button
                    type="primary"
                    icon="mdi mdi-folder-move"
                    @click="confirmMove()"
                    :loading="moveForm.busy"
                >
                    Move
                </el-button>
            </div>
        </el-dialog>

        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="copyDialogVisible"
            title="Copy Calendar to Existing Community"
            width="500px"
        >
            <el-form>
                <el-form-item
                    :class="{
                        'is-error': veeErrors.has('community_id', 'copyForm')
                    }"
                >
                    <el-select
                        data-vv-as="community"
                        data-vv-scope="copyForm"
                        filterable
                        name="community_id"
                        placeholder="Select Community..."
                        v-model="copyForm.community_id"
                        v-validate="'required'"
                    >
                        <el-option
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            v-for="item in availableCommunities"
                        />
                    </el-select>
                    <div
                        class="el-form-item__error"
                        v-if="veeErrors.has('community_id', 'copyForm')"
                    >
                        {{ veeErrors.first("community_id", "copyForm") }}
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="copyDialogVisible = false">Cancel</el-button>
                <el-button
                    type="primary"
                    icon="mdi mdi-folder-multiple"
                    @click="confirmCopy()"
                    :loading="copyForm.busy"
                >
                    Copy
                </el-button>
            </div>
        </el-dialog>
        <!-- Coupon Dialog -->
        <el-dialog
            title=""
            :visible.sync="dialogVisible"
            width="30%"
            v-if="this.coupon"
        >
            <strong>Welcome Back Discount - {{ this.coupon.name }}</strong>
            <p>
                Discount Code:
                <span class="text-uppercase">{{ this.coupon.code }}</span>
            </p>
            <p class="mb-0">Discount Type:</p>
            <p
                class="mt-0 mb-0"
                v-for="(item, coupone_types_index) in this.coupon.types.data"
                :key="coupone_types_index"
            >
                {{ item.name }}
            </p>
            <p class="mb-0">Discount Length once applied at checkout:</p>
            <p class="mt-0">{{ this.coupon.duration.name }}</p>
            <p>
                Discount Expires {{ getDate(this.coupon.valid_at) }} at midnight
                Eastern time
            </p>
        </el-dialog>
    </vue-scroll>
</template>

<script>
import InvoicePaymentLink from "@/components/InvoicePaymentLink.vue";
import * as AccountTypes from "@/constants/account-types";
import * as BusEvents from "@/constants/bus-events";
import * as CalendarFormats from "@/constants/calendar-formats";
import * as CustomChargeTypes from "@/constants/custom-charge-types";
import * as NewsletterSubtypes from "@/constants/newsletter-subtypes";
import * as NewsletterTypes from "@/constants/newsletter-types";
import * as PaymentTypes from "@/constants/payment-types";
import * as Routes from "@/constants/routes";
import auth from "@/mixins/auth";
import community_mixin from "@/mixins/community";
import * as Actions from "@/store/constants/actions";
import * as Mutations from "@/store/constants/mutations";
import { copyToClipboard } from "@/utils/clipboard";
import { mapState } from "vuex";
import CommunityUsers from "./CommunityUsers";
import EditLogo from "./EditLogo";

export default {
    mixins: [auth, community_mixin],
    components: {
        InvoicePaymentLink,
        CommunityUsers,
        EditLogo
    },
    props: {
        community: {
            type: Object,
            required: false
        },
        users: {
            type: Array,
            required: false
        },
        action: {
            type: String,
            required: false
        },
        locationToBeMoved: {
            type: Object,
            required: false
        },
        locationToBeCopied: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            AccountTypes,
            NewsletterTypes,
            NewsletterSubtypes,
            CustomChargeTypes,
            CalendarFormats,
            PaymentTypes,
            form: new Form({
                name: null,
                slug: null,
                logo: null,
                no_logo: false,
                no_calendar_logo: false,
                code: null,
                phone_number: null,
                corporation_id: null,
                account_type: null,
                payment_type: PaymentTypes.BOTH_OPTIONS,
                newsletter_type_id: null,
                newsletter_subtype: null,
                newsletter_name: null,
                newsletter_proof_link: null,
                newsletter_start: null,
                subscription_start: null,
                subscription_interval: null,
                subscription_amount: 0,
                subscription_yearly_amount: 0,
                subscription_monthly_amount: 0,
                has_ups_account: false,
                tax_exempt: false,
                disable_custom_shipping: false,
                current_issue: null,
                locations: [],
                remove_logo: false,
                notes: null,
                popup_message: null,
                announcement: null,
                address: {
                    street: "",
                    city: "",
                    state: "",
                    zip: ""
                },
                users: [],
                custom_charges: [],
                clear_custom_charges: false,
                deleted_locations: [],
                coupon: null
            }),
            logo_src: null,
            movingLocation: null,
            moveDialogVisible: false,
            moveForm: new Form({
                community_id: null
            }),
            copyingLocation: null,
            copyDialogVisible: false,
            copyForm: new Form({
                community_id: null
            }),
            oldData: null,
            dialogVisible: false,
            coupon: null,
            availableCommunities: [],
            paymentUrl: "",
            paymentUrlModalVisible: false
        };
    },
    computed: {
        ...mapState({
            items: (state) => state.communities,
            corporations: (state) => state.corporations,
            newsletterTypes: (state) => state.lists.newsletter_types.data,
            communities: (state) => state.communities.data
        }),
        hasNewsletter() {
            return _.includes(
                [
                    AccountTypes.CALENDARS_AND_NEWSLETTER,
                    AccountTypes.NEWSLETTER_ONLY
                ],
                this.form.account_type
            );
        },
        hasCalendar() {
            return _.includes(
                [
                    AccountTypes.CALENDARS_AND_NEWSLETTER,
                    AccountTypes.CALENDARS_ONLY
                ],
                this.form.account_type
            );
        },
        hasChanges() {
            if (!this.oldData) {
                return false;
            }
            return (
                JSON.stringify(this.oldData) !==
                JSON.stringify(this.getCleanFormData())
            );
        },
        selectedCorporation() {
            return _.find(this.corporations.data, {
                id: this.form.corporation_id
            });
        },
        corporateDiscounts() {
            return _.get(this.selectedCorporation, "discounts.data", []);
        },
        subscriptionAmount() {
            switch (this.form.subscription_interval) {
                case 1:
                    return parseFloat(this.form.subscription_monthly_amount);
                case 12:
                    return parseFloat(this.form.subscription_yearly_amount);
                default:
                    return 0;
            }
        },
        loginUrl() {
            if (!this.community || !this.community.slug) return "";
            return `${this.getCommunityBaseUrl(this.community)}/home`;
        }
    },
    mounted() {
        this.form.setVeeErrors(this.veeErrors);
        if (this.community) {
            _.extend(
                this.form,
                _.pick(this.community, [
                    "name",
                    "slug",
                    "phone_number",
                    "corporation_id",
                    "code",
                    "account_type",
                    "payment_type",
                    "newsletter_type_id",
                    "newsletter_subtype",
                    "newsletter_name",
                    "newsletter_proof_link",
                    "newsletter_start",
                    "subscription_interval",
                    "subscription_amount",
                    "subscription_start",
                    "notes",
                    "popup_message",
                    "announcement",
                    "current_issue",
                    "has_ups_account",
                    "no_logo",
                    "no_calendar_logo",
                    "tax_exempt",
                    "disable_custom_shipping"
                ])
            );
            _.extend(
                this.form.address,
                _.pick(this.community.address, [
                    "street",
                    "city",
                    "state",
                    "zip"
                ])
            );
            this.form.locations = _.cloneDeep(this.community.locations.data);
            this.form.custom_charges = _.cloneDeep(
                this.community.custom_charges.data
            );
            if (this.community.coupon) {
                this.form.coupon = this.community.coupon;
            }
            if (this.community.logo) {
                this.logo_src = this.community.logo.url;
            }
            switch (this.form.subscription_interval) {
                case 1:
                    this.form.subscription_monthly_amount =
                        this.form.subscription_amount;
                    break;
                case 12:
                    this.form.subscription_yearly_amount =
                        this.form.subscription_amount;
                    break;
            }
        }
        if (this.users) {
            _.forEach(this.users, (user) => {
                this.form.users.push({
                    ..._.pick(user, [
                        "id",
                        "name",
                        "email",
                        "username",
                        "phone_number",
                        "is_active",
                        "is_default_contact"
                    ]),
                    role: _.get(user, "roles.data.0.role"),
                    password: null
                });
            });
        }
        if (this.$route.query.action === "move-location") {
            this.locationToBeMoved.is_moved = true;
            this.locationToBeMoved.copied_from = this.$route.query.community_id;
            this.newLocation(this.locationToBeMoved);
        }
        if (this.$route.query.action === "copy-location") {
            let copiedLocation = {
                name: this.locationToBeCopied.name,
                code: this.locationToBeCopied.code,
                calendar_format: this.locationToBeCopied.calendar_format,
                copied_from: this.locationToBeCopied.id,
                is_moved: false
            };
            this.newLocation(copiedLocation);
        }
        this.initOldData();
        this.getAvailableCommunities();
    },
    methods: {
        getAvailableCommunities() {
            let vm = this;
            let community_id = vm.community ? vm.community.id : null;
            axios.get(`/web-api/getCommunityNames`).then((response) => {
                let communities = response.data;
                vm.availableCommunities = communities.filter(
                    (item) => item.id !== community_id
                );
            });
        },
        uppercaseForm() {
            let fields = [
                "name",
                "code",
                "newsletter_name",
                "address.street",
                "address.city",
                "address.zip"
            ];
            fields.forEach((field) => {
                _.set(
                    this.form,
                    field,
                    this.$options.filters.uppercase(_.get(this.form, field))
                );
            });
            this.form.custom_charges.forEach((charge) => {
                charge.name = this.$options.filters.uppercase(charge.name);
            });
        },
        initOldData() {
            this.uppercaseForm();
            this.oldData = this.getCleanFormData();
        },
        getCleanFormData() {
            let data = _.pick(this.form, [
                "name",
                "slug",
                "phone_number",
                "corporation_id",
                "code",
                "account_type",
                "payment_type",
                "newsletter_type_id",
                "newsletter_subtype",
                "newsletter_name",
                "newsletter_proof_link",
                "newsletter_start",
                "subscription_interval",
                "subscription_amount",
                "subscription_start",
                "subscription_monthly_amount",
                "subscription_yearly_amount",
                "notes",
                "popup_message",
                "announcement",
                "has_ups_account",
                "no_logo",
                "no_calendar_logo",
                "tax_exempt",
                "disable_custom_shipping"
            ]);
            _.extend(
                data,
                _.pick(this.form.address, ["street", "city", "state", "zip"])
            );
            data.locations = this.form.locations.map((item) =>
                _.pick(item, ["calendar_format", "name", "code", "dd_admin"])
            );
            data.custom_charges = this.form.custom_charges.map((item) =>
                _.pick(item, ["type", "name", "value"])
            );
            data.users = this.form.users.map((item) =>
                _.pick(item, [
                    "name",
                    "email",
                    "username",
                    "phone_number",
                    "is_active",
                    "is_default_contact",
                    "role"
                ])
            );
            return data;
        },
        newLocation(location = null) {
            this.form.locations.push(
                _.extend(
                    {
                        id: null,
                        name: null,
                        code: null,
                        calendar_format: null,
                        dd_admin: false,
                        copied_from: null
                    },
                    location
                )
            );
            Vue.nextTick(() => {
                window.Bus.$emit(BusEvents.UPDATE_SCROLLER);
            });
        },
        removeLocation(location) {
            this.$confirm(
                "Are you sure you want to delete location?",
                "Confirmation",
                {
                    confirmButtonClass: "el-button--danger",
                    confirmButtonText: "Delete",
                    type: "warning"
                }
            )
                .then(() => {
                    if (location.id) {
                        this.form.deleted_locations.push(location.id);
                    }
                    window.Utils.arrayDelete(this.form.locations, location);
                })
                .catch(() => {
                    //user cancelled
                });
        },
        moveLocation(location, command) {
            switch (command) {
                case "new community":
                    this.$router.push({
                        name: Routes.CREATE_COMMUNITY,
                        query: {
                            action: "move-location",
                            location_id: location.id,
                            community_id: this.community.id
                        }
                    });
                    break;
                case "existing community":
                    this.movingLocation = location;
                    this.moveDialogVisible = true;
                    break;
            }
        },
        confirmMove() {
            this.$validator.validate(null, null, "moveForm").then((valid) => {
                if (!valid) {
                    return;
                }
                window.App.post(
                    `/web-api/community/${this.community.id}/location/${this.movingLocation.id}/move`,
                    this.moveForm
                ).then(() => {
                    let selected_community = this.availableCommunities.find(
                        (item) => item[1] === this.moveForm.community_id
                    );
                    this.$notify.success({
                        message: `Location ${this.movingLocation.name} has been moved to ${selected_community[0]}.`
                    });
                    this.moveDialogVisible = false;
                    window.Utils.arrayDelete(
                        this.form.locations,
                        this.movingLocation
                    );
                    this.$store.dispatch(
                        Actions.UPDATE_COMMUNITY,
                        this.community
                    );
                    //             this.$store.dispatch(Actions.UPDATE_COMMUNITY, selected_community);
                });
            });
        },
        copyLocation(location, command) {
            switch (command) {
                case "new community":
                    this.$router.push({
                        name: Routes.CREATE_COMMUNITY,
                        query: {
                            action: "copy-location",
                            location_id: location.id,
                            community_id: this.community.id
                        }
                    });
                    break;
                case "existing community":
                    this.copyingLocation = location;
                    this.copyDialogVisible = true;
                    break;
            }
        },
        confirmCopy() {
            this.$validator.validate(null, null, "copyForm").then((valid) => {
                if (!valid) {
                    return;
                }
                window.App.post(
                    `/web-api/community/${this.community.id}/location/${this.copyingLocation.id}/copy`,
                    this.copyForm
                ).then(() => {
                    let selected_community = this.availableCommunities.find(
                        (item) => item[1] === this.copyForm.community_id
                    );
                    this.$notify.success({
                        message: `Location ${this.copyingLocation.name} has been copied to ${selected_community[0]}.`
                    });
                    this.copyDialogVisible = false;
                    this.$store.dispatch(
                        Actions.UPDATE_COMMUNITY,
                        this.community
                    );
                    //   this.$store.dispatch(Actions.UPDATE_COMMUNITY, selected_community);
                });
            });
        },
        onChangeSubscriptionType() {
            switch (this.form.account_type) {
                case AccountTypes.CALENDARS_ONLY:
                    this.form.newsletter_type_id = null;
                    this.form.newsletter_subtype = null;
                    break;
                case AccountTypes.NEWSLETTER_ONLY:
                    this.form.newsletter_subtype = null;
                    if (
                        !_.includes(
                            [
                                NewsletterTypes.FLEX_FOUR,
                                NewsletterTypes.READERS_DELIGHT
                            ],
                            this.form.newsletter_type_id
                        )
                    ) {
                        this.form.newsletter_type_id = null;
                    }
                    break;
            }
        },
        onChangeNewsletterType() {
            this.form.newsletter_subtype = null;
        },
        filteredCustomCharges(type) {
            return this.form.custom_charges.filter((item, i) => {
                Vue.set(item, "_index", i);
                Vue.set(item, "_name_name", `custom_charges.${i}.name`);
                Vue.set(item, "_value_name", `custom_charges.${i}.value`);
                return item.type === type;
            });
        },
        addCustomCharge(type) {
            this.form.custom_charges.push({
                name: null,
                type,
                value: 0
            });
        },
        removeCustomCharge(item) {
            Utils.arrayDelete(this.form.custom_charges, item);
        },
        submit() {
            this.uppercaseForm();
            this.$validator
                .validate()
                .then((valid) => {
                    if (!valid) {
                        console.log(this.$validator.errors);
                        if (this.$validator.errors.items) {
                            this.$notify.error(
                                this.$validator.errors.items
                                    .map((error) => error.msg)
                                    .join("\n")
                            );
                        }
                        return;
                    }
                    switch (this.form.subscription_interval) {
                        case 1:
                            this.form.subscription_amount =
                                this.form.subscription_monthly_amount;
                            break;
                        case 12:
                            this.form.subscription_amount =
                                this.form.subscription_yearly_amount;
                            break;
                    }
                    if (this.community) {
                        this.form.clear_custom_charges =
                            !this.form.custom_charges.length;
                        window.App.putData(
                            `/web-api/community/${this.community.id}`,
                            this.form
                        ).then((response) => {
                            this.$notify.success({
                                message: `Changes have been saved`
                            });
                            this.$store.commit(
                                Mutations.UPDATE_COMMUNITY,
                                response.data
                            );
                            this.initOldData();
                            this.back();
                        });
                    } else {
                        window.App.postData(
                            `/web-api/community`,
                            this.form
                        ).then((response) => {
                            this.$notify.success({
                                message: `New community has been created.`
                            });
                            this.$store.commit(
                                Mutations.NEW_COMMUNITY,
                                response.data
                            );
                            if (this.locationToBeMoved) {
                                this.$store.dispatch(Actions.UPDATE_COMMUNITY, {
                                    id: this.locationToBeMoved.community_id
                                });
                            }
                            this.initOldData();
                            this.back();
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        back() {
            this.$router.push({
                name: Routes.COMMUNITIES
            });
        },
        deleteCommunity() {
            this.$confirm(
                "Are you sure you want to delete this community?",
                "Confirmation",
                {
                    confirmButtonText: "Delete",
                    confirmButtonClass: "el-button--danger",
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    axios
                        .delete(`/web-api/community/${this.community.id}`)
                        .then(() => {
                            this.$store.commit(
                                Mutations.DELETE_COMMUNITY,
                                this.community
                            );
                            this.$notify.success({
                                message: `Community ${this.community.name} has been deleted.`
                            });
                            this.back();
                        })
                        .catch((e) => {
                            console.log(e);
                            this.$notify.error({
                                message: `Cannot delete ${this.community.name}.`
                            });
                        });
                })
                .catch(() => {
                    //user cancelled
                });
        },
        onChangeCorporation() {
            if (this.selectedCorporation) {
                this.inheritSubscriptionFromCorporation();
                this.inheritPaymentTypeFromCorporation();
                this.$notify.info({
                    message: `Corporate subscription amount and payment type has been auto-populated.`
                });
            }
        },
        inheritSubscriptionFromCorporation() {
            this.form.subscription_monthly_amount =
                this.selectedCorporation.monthly_subscription;
            this.form.subscription_yearly_amount =
                this.selectedCorporation.annual_subscription;
        },
        inheritPaymentTypeFromCorporation() {
            this.form.payment_type = this.selectedCorporation.payment_type;
        },
        viewCoupon(id) {
            axios
                .get(
                    `/web-api/coupon/${id}?include=duration,types,communities,logs`
                )
                .then((response) => {
                    this.coupon = response.data;
                    this.dialogVisible = true;
                });
        },
        getDate(date) {
            return moment(date).format("MMM DD, YYYY");
        },
        login() {
            window.open(this.loginUrl, "_blank");
        },
        copyLoginUrl() {
            copyToClipboard(this.loginUrl).then((success) => {
                if (success) {
                    this.$message({
                        message: "Login URL copied to clipboard.",
                        type: "success"
                    });
                } else {
                    this.$message({
                        type: "warning",
                        message: "Failed to copy URL"
                    });
                }
            });
        },
        goToProofLink() {
            window.open(`${this.form.newsletter_proof_link}`, "_blank");
        },
        copyProofLink() {
            copyToClipboard(this.form.newsletter_proof_link).then((success) => {
                if (success) {
                    this.$message({
                        message: "Link copied to clipboard.",
                        type: "success"
                    });
                } else {
                    this.$message({
                        message: "Failed to copy link.",
                        type: "warning"
                    });
                }
            });
        },
        viewLogs() {
            window.open(`logs`, "_blank");
        }
    },
    watch: {
        "form.slug"(value) {
            if (this.community) {
                return;
            }
            this.form.code = value;
        }
    }
};
</script>

<style lang="scss" scoped>
.community-locations {
    .community-locations__item {
        &:not(:first-of-type) {
            margin-top: 1rem;
        }
        .dd_admin {
            min-width: 180px;
        }
    }
}

.logo-container {
    width: 150px;
    height: 150px;
    position: relative;

    .remove-logo {
        position: absolute;
        top: 0;
        right: 0;
    }

    .image {
        width: 150px;
        height: 150px;
        background-size: contain;
        background-repeat: no-repeat;
    }
}

.login-url-container {
    display: flex;
    align-items: center;
    margin-top: 5px;
    font-size: 0.9em;
    
    .el-link {
        max-width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>
